import { Separator } from "@base-ui/react/separator";
import Typography from "../ui/typography";

const PageHeader = ({
  title,
  description,
}: {
  title: string;
  description?: string;
}) => {
  return (
    <>
      <div>
        <Typography variant="title">{title}</Typography>
        {description && (
          <p className="text-xl leading-6.5 font-medium pl-1">{description}</p>
        )}
      </div>
      <Separator
        className="bg-neutral-200 h-px my-4"
        orientation="horizontal"
      />
    </>
  );
};

export default PageHeader;
